module.exports = __webpack_public_path__ + "img/余额表.912fa4e6.png";